// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.menubar-module__menubar__aG93n {
    /* padding: 10px; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 18px;
    /* border-bottom: 1px solid #ddd; */
}

.menubar-module__left__i9ITN {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    flex: 0 0 auto;
    gap: 16px;
}



.menubar-module__right__ixVr_ {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
    flex: 1 1 auto;
    min-width: 0;
}

.menubar-module__logo__dH_fb {
    height: 32px;
    width: auto;
}

.menubar-module__hamburgerWrapper__xle3a {
    display: none;
    position: relative;
}

.menubar-module__hamburger__bhmat {
    border: 1px solid #ddd;
    background: white;
    padding: 6px 10px;
    border-radius: 8px;
    cursor: pointer;
    line-height: 1;
    font-size: 18px;
}

.menubar-module__mobileMenu__kGoKd {
    position: absolute;
    top: 100%;
    right: 0;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: white;
    white-space: nowrap;
    z-index: 100;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.menubar-module__mobileMenuButtons__RHHkp {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.menubar-module__mobileMessagesButton__uRC7U {
    position: relative;
    display: flex;
}

.menubar-module__mobileMessagesButton__uRC7U button {
    flex: 1;
}

.menubar-module__messagesButton__IJV7C {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.menubar-module__messageIndicator__kgbmZ {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: red;
    position: absolute;
    top: 3px;
    right: 3px;
}

.menubar-module__hamburgerIndicator__t7yA1 {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: red;
    position: absolute;
    top: 3px;
    right: 3px;
    pointer-events: none;
}

@media (max-width: 768px) {
    .menubar-module__right__ixVr_ {
        display: none;
    }

    .menubar-module__hamburgerWrapper__xle3a {
        display: block;
    }

    /* optionally hide the greeting on very small screens */
    .menubar-module__greeting__kUTcg {
        display: none;
    }
}



/* Automations alert dot — mirrors .messagesButton / .messageIndicator.
   Colors match the Rules screen badges (.alertBadgeFired #e03e3e,
   .alertBadgePending #e08c00) so the dot and the badge agree. */
.menubar-module__automationsButton__XoiyO {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.menubar-module__mobileAutomationsButton__yG_Ed {
    position: relative;
    display: flex;
}

.menubar-module__mobileAutomationsButton__yG_Ed button {
    flex: 1;
}

.menubar-module__alertIndicator__E2Fcu {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #e03e3e;
    position: absolute;
    top: 3px;
    right: 3px;
}

.menubar-module__warnIndicator__plo1b {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #e08c00;
    position: absolute;
    top: 3px;
    right: 3px;
}

.menubar-module__hamburgerIndicatorWarn__Ko9iK {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #e08c00;
    position: absolute;
    top: 3px;
    right: 3px;
    pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./code/app/MenuBar/menubar.module.css"],"names":[],"mappings":";;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,SAAS;AACb;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA,uDAAuD;IACvD;QACI,aAAa;IACjB;AACJ;;;;AAIA;;gEAEgE;AAChE;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oBAAoB;AACxB","sourcesContent":["\n\n.menubar {\n    /* padding: 10px; */\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 18px;\n    /* border-bottom: 1px solid #ddd; */\n}\n\n.left {\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    flex: 0 0 auto;\n    gap: 16px;\n}\n\n\n\n.right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.logo {\n    height: 32px;\n    width: auto;\n}\n\n.hamburgerWrapper {\n    display: none;\n    position: relative;\n}\n\n.hamburger {\n    border: 1px solid #ddd;\n    background: white;\n    padding: 6px 10px;\n    border-radius: 8px;\n    cursor: pointer;\n    line-height: 1;\n    font-size: 18px;\n}\n\n.mobileMenu {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background: white;\n    white-space: nowrap;\n    z-index: 100;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n.mobileMenuButtons {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.mobileMessagesButton {\n    position: relative;\n    display: flex;\n}\n\n.mobileMessagesButton button {\n    flex: 1;\n}\n\n.messagesButton {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n}\n\n.messageIndicator {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: red;\n    position: absolute;\n    top: 3px;\n    right: 3px;\n}\n\n.hamburgerIndicator {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: red;\n    position: absolute;\n    top: 3px;\n    right: 3px;\n    pointer-events: none;\n}\n\n@media (max-width: 768px) {\n    .right {\n        display: none;\n    }\n\n    .hamburgerWrapper {\n        display: block;\n    }\n\n    /* optionally hide the greeting on very small screens */\n    .greeting {\n        display: none;\n    }\n}\n\n\n\n/* Automations alert dot — mirrors .messagesButton / .messageIndicator.\n   Colors match the Rules screen badges (.alertBadgeFired #e03e3e,\n   .alertBadgePending #e08c00) so the dot and the badge agree. */\n.automationsButton {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n}\n\n.mobileAutomationsButton {\n    position: relative;\n    display: flex;\n}\n\n.mobileAutomationsButton button {\n    flex: 1;\n}\n\n.alertIndicator {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #e03e3e;\n    position: absolute;\n    top: 3px;\n    right: 3px;\n}\n\n.warnIndicator {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #e08c00;\n    position: absolute;\n    top: 3px;\n    right: 3px;\n}\n\n.hamburgerIndicatorWarn {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #e08c00;\n    position: absolute;\n    top: 3px;\n    right: 3px;\n    pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menubar": `menubar-module__menubar__aG93n`,
	"left": `menubar-module__left__i9ITN`,
	"right": `menubar-module__right__ixVr_`,
	"logo": `menubar-module__logo__dH_fb`,
	"hamburgerWrapper": `menubar-module__hamburgerWrapper__xle3a`,
	"hamburger": `menubar-module__hamburger__bhmat`,
	"mobileMenu": `menubar-module__mobileMenu__kGoKd`,
	"mobileMenuButtons": `menubar-module__mobileMenuButtons__RHHkp`,
	"mobileMessagesButton": `menubar-module__mobileMessagesButton__uRC7U`,
	"messagesButton": `menubar-module__messagesButton__IJV7C`,
	"messageIndicator": `menubar-module__messageIndicator__kgbmZ`,
	"hamburgerIndicator": `menubar-module__hamburgerIndicator__t7yA1`,
	"greeting": `menubar-module__greeting__kUTcg`,
	"automationsButton": `menubar-module__automationsButton__XoiyO`,
	"mobileAutomationsButton": `menubar-module__mobileAutomationsButton__yG_Ed`,
	"alertIndicator": `menubar-module__alertIndicator__E2Fcu`,
	"warnIndicator": `menubar-module__warnIndicator__plo1b`,
	"hamburgerIndicatorWarn": `menubar-module__hamburgerIndicatorWarn__Ko9iK`
};
export default ___CSS_LOADER_EXPORT___;
